/**
 * The keys whose slice is a different object than the one sent last. Redux
 * slices are immutable, so a reference check is exact and costs nothing; a
 * key never sent counts as changed.
 */
export const changedKeys = <S, K extends keyof S>(
	lastSent: Partial<S>,
	next: S,
	keys: ReadonlyArray<K>
): K[] => keys.filter(key => !(key in lastSent) || lastSent[key] !== next[key])

/** The references to remember as sent, for the next comparison. */
export const rememberSent = <S, K extends keyof S>(
	lastSent: Partial<S>,
	next: S,
	keys: ReadonlyArray<K>
): Partial<S> => {
	const remembered: Partial<S> = { ...lastSent }
	keys.forEach(key => {
		remembered[key] = next[key]
	})
	return remembered
}
